import React from 'react';
import Router from './app/router';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { ToastContainer } from 'react-toastify';

// The one toast container. react-toastify 11 tracks containers by containerId,
// so a container per page would drop toasts when a popup's copy unmounts.
const App = () => (

<HelmetProvider>
   <Router />
   <ToastContainer />
</HelmetProvider>
  );

  export default App;